import React from 'react';
import classes from './FaqAccordion.module.scss';
import A from '../../atoms/A/A';
import Collapsible from '../../atoms/Collapsible/Collapsible';
import LinkIcon from './link.svg';
import Txt from '../../atoms/Txt/Txt';
import { useRouter } from 'next/router';

interface Question {
  key?: string;
  question: string;
  answer: React.ReactNode;
}

export interface Props {
  heading?: string;
  questions: Question[];
  id?: string;
}

const FaqAccordion: React.FC<Props> = ({ heading, questions, id }) => {
  const router = useRouter();

  return (
    <section className={classes.root}>
      {heading && (
        <div id={id} className={classes.sectionHeading}>
          <Txt component="h2">{heading}</Txt>
          <A to={`${router.pathname}#${id}`}>
            <LinkIcon className={classes.largeLinkIcon} />
          </A>
        </div>
      )}
      {questions.map((Item) => {
        const { key, question, answer } = Item;
        return (
          <Collapsible
            itemScope
            itemProp="mainEntry"
            itemType="https://schema.org/Question"
            className={classes.collapsible}
            key={key || question}
            title={
              <Txt component="h3" id={key} size="normal" itemProp="name">
                {question}{' '}
                <A to={`${router.pathname}#${key}`}>
                  <LinkIcon className={classes.linkIcon} />
                </A>
              </Txt>
            }
            headerClassName={classes.questionHeader}
          >
            <div
              className={classes.answer}
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              {answer}
            </div>
          </Collapsible>
        );
      })}
    </section>
  );
};

export default FaqAccordion;
